import { render, staticRenderFns } from "./ChatroomForm.vue?vue&type=template&id=68759e34&"
import script from "./ChatroomForm.vue?vue&type=script&lang=js&"
export * from "./ChatroomForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports